

// import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

// @Component({
//   selector: 'app-pagination',
//   templateUrl: './pagination.component.html',
//   styleUrls: ['./pagination.component.scss']
// })
// export class PaginationComponent {
//     @Input() totalItems: number;
//     @Input() currentPage: number;
//     @Input() itemsPerPage: number;
//     @Input() totalPages: number;
//     @Output() onClick: EventEmitter<number> = new EventEmitter();
    
//     pages: number[] = [];
//     maxVisiblePages: number = 5;

//     ngOnChanges(changes: SimpleChanges): void {
//       if (changes['totalPages'] || changes['currentPage']) {
//         this.updatePageRange();
//       }
//     }

//     // Update the displayed page range based on the current page
//     updatePageRange() {
//       const halfRange = Math.floor(this.maxVisiblePages / 2);
//       let startPage = Math.max(1, this.currentPage - halfRange);
//       let endPage = Math.min(this.totalPages, startPage + this.maxVisiblePages - 1);

//       // Adjust startPage if we're at the end of the page list
//       if (endPage - startPage + 1 < this.maxVisiblePages) {
//         startPage = Math.max(1, endPage - this.maxVisiblePages + 1);
//       }

//       this.pages = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
//     }

//     pageClicked(page: number) {
//       if (page >= 1 && page <= this.totalPages) {
//         this.onClick.emit(page);
//       }
//     }

//     goToFirstPage() {
//       this.onClick.emit(1);
//     }

//     goToLastPage() {
//       this.onClick.emit(this.totalPages);
//     }
// }

import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnChanges {
  @Input() totalItems = 0;
  @Input() currentPage = 1;
  @Input() itemsPerPage = 7;
  @Input() totalPages = 0;
  @Output() onClick = new EventEmitter<number>();

  pages: number[] = [];
  readonly maxVisiblePages = 5;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['totalPages'] || changes['currentPage']) {
      this.updatePageRange();
    }
  }

  updatePageRange(): void {
    const totalPages = this.getTotalPages();

    if (totalPages === 0) {
      this.pages = [];
      return;
    }

    const currentPage = Math.min(
      Math.max(1, Math.floor(Number(this.currentPage) || 1)),
      totalPages,
    );
    const halfRange = Math.floor(this.maxVisiblePages / 2);
    let startPage = Math.max(1, currentPage - halfRange);
    let endPage = Math.min(totalPages, startPage + this.maxVisiblePages - 1);

    // Keep the full visible range when there are enough pages near the end.
    if (endPage - startPage + 1 < this.maxVisiblePages) {
      startPage = Math.max(1, endPage - this.maxVisiblePages + 1);
    }

    this.pages = Array.from(
      { length: Math.max(0, endPage - startPage + 1) },
      (_, index) => startPage + index,
    );
  }

  pageClicked(page: number): void {
    const totalPages = this.getTotalPages();
    if (Number.isInteger(page) && page >= 1 && page <= totalPages && page !== this.currentPage) {
      this.onClick.emit(page);
    }
  }

  goToFirstPage(): void {
    this.pageClicked(1);
  }

  goToLastPage(): void {
    this.pageClicked(this.getTotalPages());
  }

  private getTotalPages(): number {
    const parsed = Math.floor(Number(this.totalPages));
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
  }
}


